/**
 * @define Expandable.Header
 * Expandable.Item.Header Component
 */
// Vendor
import React, { useEffect, useRef } from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Heading, { types } from "../../../../elements/Heading";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";

var Header = function Header(_ref) {
  var id = _ref.id,
      idContent = _ref.idContent,
      children = _ref.children,
      onClick = _ref.onClick,
      isExpanded = _ref.isExpanded,
      buttonLabel = _ref.buttonLabel,
      headingRank = _ref.headingRank,
      _ref$isScrollable = _ref.isScrollable,
      isScrollable = _ref$isScrollable === void 0 ? true : _ref$isScrollable,
      isAccordion = _ref.isAccordion,
      dataAnalyticsElementType = _ref.dataAnalyticsElementType;
  var getClassName = getClassNameFactory(Header.displayName);
  var chevronClassName = getClassName({
    descendantName: "chevron"
  });
  var headerRef = useRef(null);
  useEffect(function () {
    if (isScrollable && headerRef.current && isExpanded && !isAccordion) {
      var _headerRef$current$ge = headerRef.current.getBoundingClientRect(),
          top = _headerRef$current$ge.top,
          bottom = _headerRef$current$ge.bottom;

      if (bottom > window.innerHeight || top < 0) {
        headerRef.current.scrollIntoView({
          block: "center"
        });
      }
    }
  }, [isScrollable, isExpanded]);
  return /*#__PURE__*/React.createElement("button", {
    "aria-controls": idContent,
    "aria-label": buttonLabel,
    "aria-expanded": isExpanded,
    "data-analytics-element-type": dataAnalyticsElementType,
    onClick: onClick,
    className: getClassName({
      states: isExpanded ? "expanded" : "collapsed"
    }),
    id: id,
    ref: headerRef
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: headingRank,
    type: types.Small
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "headingInner"
    })
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: chevronClassName
  }, isExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null)));
};

Header.displayName = "Expandable.Item.Header";
export default Header;